const campaignThrottlingMode = Object.freeze({
  DISABLED: 0,
  DELIVERY_WINDOW: 1,
  RATE_LIMIT: 2
})

const campaignThrottlingModeLabels = Object.freeze({
  [campaignThrottlingMode.DISABLED]:
    'ProjectSettings_Field_Feature_CampaignThrottling_Disabled',
  [campaignThrottlingMode.DELIVERY_WINDOW]:
    'ProjectSettings_Field_Feature_CampaignThrottling_DeliveryWindow',
  [campaignThrottlingMode.RATE_LIMIT]:
    'ProjectSettings_Field_Feature_CampaignThrottling_RateLimit'
})

export { campaignThrottlingMode, campaignThrottlingModeLabels }



// WEBPACK FOOTER //
// ./src/modules/project/enum/CampaignThrottlingModeEnum.js